import { Link } from "react-router-dom";

const Heading = ({
  sx,
  size = "text-xl",
  color = "inverse",
  bg = "bg-primary",
  type = "h2",
  p = "2",
  linkTo,
  linkText = "Visa alla",
  mb = "6",
  ...props
}) => {
  // Common props for all heading types
  const commonProps = {
    className: `${size} font-bold ${bg} p-${p} text-${color} shadow-md ${sx ? sx : ""}`,
    ...props,
  };

  // Create the heading element with optional link
  const renderHeading = (element) => {
    return (
      <div className={`flex mb-${mb}`}>
        {element}
        {linkTo && (
          <Link
            to={linkTo}
            className="bg-gray500 hover:bg-primary500 text-inverse p-1 self-start hover:text-inverse transition-colors duration-300"
          >
            {linkText}
          </Link>
        )}
      </div>
    );
  };

  // Render the appropriate heading element based on type
  switch (type) {
    case "h1":
      return renderHeading(<h1 {...commonProps} />);
    case "h2":
      return renderHeading(<h2 {...commonProps} />);
    case "h3":
      return renderHeading(<h3 {...commonProps} />);
    case "h4":
      return renderHeading(<h4 {...commonProps} />);
    case "h5":
      return renderHeading(<h5 {...commonProps} />);
    case "h6":
      return renderHeading(<h6 {...commonProps} />);
    default:
      return renderHeading(<h2 {...commonProps} />);
  }
};

export default Heading;
